export const getInvoice = (invoiceId) => ({ testInvoices }) =>
  testInvoices.invoicesList.find(({ id }) => id === invoiceId);
